import { useState, useEffect } from 'react';
import { Song } from '../components/view/spotipitan/types';
import { CanvasVideoUrlResponse } from '../utils/apiTypes';
import { getCanvasVideoUrl, normalizeFileUrl } from '../utils/api';

export interface UseTrackCanvasResult {
    canvasInfo: CanvasVideoUrlResponse | undefined;
    canvasUrl: string | null;
    hasCanvas: boolean;
    loading: boolean;
}

export const useTrackCanvas = (song?: Song | null): UseTrackCanvasResult => {
    const [canvasInfo, setCanvasInfo] = useState<CanvasVideoUrlResponse | undefined>(undefined);
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        if (!song?.id) {
            setCanvasInfo(undefined);
            setLoading(false);
            return;
        }

        let cancelled = false;
        setLoading(true);
        setCanvasInfo(undefined);

        getCanvasVideoUrl(song).then((res) => {
            if (cancelled) return;
            setCanvasInfo(res?.canvasUrl ? res : undefined);
            setLoading(false);
        }).catch(() => {
            if (cancelled) return;
            setCanvasInfo(undefined);
            setLoading(false);
        });

        return () => {
            cancelled = true;
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [song?.id, song?.name, song?.canvas_url]);

    const resolvedCanvasUrl = canvasInfo?.canvasUrl
        ? normalizeFileUrl(canvasInfo.canvasUrl)
        : (song?.canvas_url ? normalizeFileUrl(song.canvas_url) : null);

    return {
        canvasInfo,
        canvasUrl: resolvedCanvasUrl,
        hasCanvas: !!resolvedCanvasUrl,
        loading
    };
};

export default useTrackCanvas;
